import { H5 as BluBlocksH5, Theme } from "@bluframe/blublocks"
import styled from "styled-components"
import mediaQueries from "styles/mediaQueries"

const H5 = styled(BluBlocksH5)`
  color: ${({ theme }: { theme: Theme }) => theme.palette.text.main};
  font-weight: 500;
  line-height: 1.1;
  font-size: 18px;
  margin-top: 0;

  ${mediaQueries.tablet} {
    font-size: 20px;
  }
`

export default H5
